<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card" id="followupApprovalPage">
        <h4>
          Follow-up Email<span v-if="data && data.stepNo"> {{ data.stepNo }}<span v-if="data.stepsTotal"> of {{ data.stepsTotal }}</span></span>
          <span v-if="data"> for Quote: {{ data.quoteRef }}<span v-if="data.project"> - {{ data.project }}</span></span>
        </h4>
        <p v-if="loadError" class="p-invalid">{{ loadError }}</p>
        <template v-if="data">
          <p>
            To: <b>{{ data.contactName }}</b><span v-if="data.contactEmail"> / {{ data.contactEmail }}</span><span v-if="data.customerName"> at {{ data.customerName }}</span>.
            <router-link v-if="data.oppId" :to="'/enquiries/' + data.oppId + '/followup'">Open the quote's Follow-up tab</router-link>
          </p>
          <p id="statusLine" class="status-line">{{ status }}</p>

          <div class="email-box p-mb-3">
            <div><b>Subject:</b> {{ data.subject }}</div>
            <pre class="email-body">{{ data.body }}</pre>
            <small v-if="data.edited" class="hint">This is the text as edited for this quote.</small>
          </div>

          <div v-if="done" id="approvalDone" class="p-mb-3"><b>{{ done }}</b></div>

          <div v-if="data.canChange && !done">
            <div class="p-d-flex p-flex-wrap p-mb-3">
              <Button v-for="a in actions" :key="a" :id="'choose-' + a" :label="labels[a]" style="width: auto" class="p-mr-2 p-mb-2"
                :class="action === a ? '' : 'p-button-outlined'" @click="choose(a)" />
            </div>

            <div v-if="action === 'edit'" id="editPanel" class="p-fluid">
              <div class="p-field">
                <label for="editSubject">Subject</label>
                <InputText id="editSubject" v-model="form.subject" />
              </div>
              <div class="p-field">
                <label for="editBody">Message</label>
                <Textarea id="editBody" v-model="form.body" :autoResize="true" rows="10" />
                <small class="hint">Your text goes for this quote only, in this email. It still goes on its date.</small>
              </div>
            </div>

            <div v-if="action === 'pause'" id="pausePanel">
              <p class="p-mt-0">Send this email later by:</p>
              <div class="p-d-flex p-mb-2">
                <Button v-for="d in pauseDays" :key="d" :id="'pause-' + d" :label="daysLabel(d)" style="width: auto" class="p-mr-2"
                  :class="form.days === d ? '' : 'p-button-outlined'" @click="form.days = d" />
              </div>
              <small class="hint">It then goes the next time emails are sent after that. You can pause it again.</small>
            </div>

            <div v-if="action === 'stop'" id="stopPanel">
              <p class="p-mt-0">No more follow-up emails go for this quote, this one included.</p>
            </div>

            <template v-if="action">
              <small v-if="problem" class="p-invalid p-d-block p-mb-2">{{ problem }}</small>
              <Button id="sendAnswer" :label="sendLabel" icon="pi pi-check" style="width: auto" :disabled="saving"
                :class="action === 'stop' ? 'p-button-danger' : ''" @click="send" />
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FollowupService, { errorMessage } from '@/service/FollowupService'
import { ACTIONS, PAUSE_DAYS, startAction, startDays, linkStep, daysLabel, answerBody, doneMessage, statusLine } from './followupApproval'

export default {
  // Decision 3 (14/10): opened from the reminder the day before each follow-up email, after sign-in
  name: 'FollowupApproval',
  data() {
    var query = this.$route && this.$route.query
    return {
      followupService: new FollowupService(),
      data: null,
      loadError: '',
      action: startAction(query),
      step: linkStep(query),
      actions: ACTIONS,
      labels: { edit: 'Edit the text', pause: 'Pause', stop: 'Stop' },
      pauseDays: PAUSE_DAYS,
      form: { subject: '', body: '', days: startDays(query) },
      problem: '',
      saving: false,
      done: ''
    }
  },
  computed: {
    status() { return statusLine(this.data, this.step) },
    sendLabel() {
      if (this.action === 'edit') return 'Save the text'
      if (this.action === 'pause') return this.form.days ? 'Pause ' + daysLabel(this.form.days) : 'Pause'
      return 'Stop the emails'
    }
  },
  created() {
    this.load()
  },
  methods: {
    daysLabel,
    show(d) {
      this.data = d
      this.form.subject = d.subject || ''
      this.form.body = d.body || ''
    },
    load() {
      return this.followupService.approval(this.$route.params.followupId)
        .then(d => this.show(d))
        .catch(err => { this.loadError = errorMessage(err, 'This follow-up could not be loaded.') })
    },
    choose(a) {
      this.action = a
      this.problem = ''
    },
    send() {
      var a = answerBody(this.action, this.form, this.data && this.data.stepNo)
      if (a.problem) { this.problem = a.problem; return Promise.resolve() }
      this.problem = ''
      this.saving = true
      return this.followupService.answerApproval(this.$route.params.followupId, a.body)
        .then(answer => {
          if (answer) this.show(answer)
          this.done = doneMessage(this.action, a.body, answer)
        })
        .catch(err => { this.problem = errorMessage(err, 'Your change could not be saved.') })
        .finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.email-box { border: 1px solid #dee2e6; border-radius: 4px; padding: 0.75rem; background: #f8f9fa; }
.email-body { white-space: pre-wrap; font-family: inherit; margin: 0.5rem 0 0; }
.status-line { font-weight: 600; }
.hint { color: #6c757d; }
</style>
